import React, { useEffect, useState } from 'react';
import { TopNav } from '../components/TopNav';
import { WeeklyWorkflowKanban } from '../components/WeeklyWorkflowKanban';
import { listKanban, createKanban, deleteKanban } from '@/services/kanban';

interface PageProps { theme: string; toggleTheme: () => void }

const WorkflowPage: React.FC<PageProps> = ({ theme, toggleTheme }) => {
  const [data, setData] = useState<any[]>([]);
  const [task, setTask] = useState({ day: 'Segunda', title: '', time: '', location: '', category: 'reuniao' });

  useEffect(() => {
    (async () => {
      try { setData(await listKanban()); } catch {}
    })();
  }, []);

  return (
    <div className="min-h-screen bg-body">
      <TopNav theme={theme} toggleTheme={toggleTheme} />
      <main className="max-w-7xl mx-auto p-3 md:p-4">
        <h1 className="text-xl font-extrabold text-primary mb-3">Workflow</h1>
        <p className="text-sm text-muted mb-4">Planejamento semanal e tarefas.</p>
        <div className="bg-white dark:bg-[#181818] border border-zinc-200 dark:border-zinc-800 rounded-lg p-3 mb-3 grid grid-cols-1 md:grid-cols-5 gap-2 items-end">
          <div>
            <label className="text-xs text-muted">Dia</label>
            <select className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={task.day} onChange={e=>setTask(prev=>({ ...prev, day: e.target.value }))}>
              {['Segunda','Terça','Quarta','Quinta','Sexta'].map(d=> <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs text-muted">Título</label>
            <input className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={task.title} onChange={e=>setTask(prev=>({ ...prev, title: e.target.value }))}/>
          </div>
          <div>
            <label className="text-xs text-muted">Hora</label>
            <input className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={task.time} onChange={e=>setTask(prev=>({ ...prev, time: e.target.value }))}/>
          </div>
          <div>
            <label className="text-xs text-muted">Local</label>
            <input className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={task.location} onChange={e=>setTask(prev=>({ ...prev, location: e.target.value }))}/>
          </div>
          <div>
            <label className="text-xs text-muted">Categoria</label>
            <select className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800" value={task.category} onChange={e=>setTask(prev=>({ ...prev, category: e.target.value }))}>
              {['reuniao','analise','relatorio','criativo','admin','social','planejamento'].map(c=> <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <button className="md:col-span-5 px-3 py-2 rounded-md bg-zinc-900 text-white dark:bg-green-500 dark:text-black" onClick={async()=>{
            if(!task.title||!task.time) return; await createKanban(task as any); setTask({ day: 'Segunda', title: '', time: '', location: '', category: 'reuniao' }); setData(await listKanban());
          }}>Adicionar tarefa</button>
        </div>
        <WeeklyWorkflowKanban data={data as any} />
        <div className="mt-3 text-sm">
          <p className="font-semibold mb-2">Tarefas (admin)</p>
          <ul className="space-y-1">
            {data.map((t:any)=> (
              <li key={t.id} className="flex items-center justify-between">
                <span className="text-muted truncate mr-2">{t.day} — {t.title}</span>
                <button className="text-red-500 text-xs" onClick={async()=>{ await deleteKanban(t.id); setData(await listKanban()); }}>excluir</button>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </div>
  );
};

export default WorkflowPage;



